(function () {
  class MediaBannerScrollInfo {
    constructor(section) {
      this.section = section;
      this.root = section.querySelector(".media-banner");
      this.panel = section.querySelector("[data-media-banner-scroll-info]");
      this.sticky = section.querySelector(".media-banner__sticky");
      this.track = section.querySelector(".media-banner__track");
      if (!this.root || !this.panel || !this.sticky || !this.track) return;

      this.progress = -1;
      this.raf = null;
      this.eventController = new AbortController();

      this.root.classList.add("media-banner--has-scroll-info");

      this._onScroll = this._onScroll.bind(this);
      this._measure = this._measure.bind(this);

      window.addEventListener("scroll", this._onScroll, {
        passive: true,
        signal: this.eventController.signal,
      });
      window.addEventListener("resize", this._onResize.bind(this), {
        passive: true,
        signal: this.eventController.signal,
      });

      this._measure();
      this._update();
    }

    // Track = pinned content height + one panel-height of reveal room, so the
    // section stays pinned at the viewport top while the panel slides fully in.
    _measure() {
      const stickyHeight = this.sticky.offsetHeight || 0;
      this.revealDistance = stickyHeight;
      this.track.style.setProperty(
        "--scroll-info-track-height",
        stickyHeight + this.revealDistance + "px"
      );
    }

    _onResize() {
      this._measure();
      this._onScroll();
    }

    _onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this._update();
      });
    }

    _update() {
      const reveal = this.revealDistance || 1;
      // The track top relative to the viewport. While the section is pinned
      // (track top scrolled above 0) the panel reveals over `reveal` px.
      const trackTop = this.track.getBoundingClientRect().top;
      const progress = Math.min(Math.max(-trackTop / reveal, 0), 1);

      if (progress === this.progress) return;
      this.progress = progress;
      this.panel.style.setProperty(
        "--scroll-info-progress",
        progress.toFixed(4)
      );
    }

    destroy() {
      if (this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
      this.eventController.abort();
      if (this.root) {
        this.root.classList.remove("media-banner--has-scroll-info");
      }
      if (this.track) {
        this.track.style.removeProperty("--scroll-info-track-height");
      }
      if (this.panel) {
        this.panel.style.removeProperty("--scroll-info-progress");
      }
    }
  }

  function initSection(section) {
    if (!section || !section.classList.contains("media-banner-section")) return;

    if (section._mediaBannerScrollInfo) {
      section._mediaBannerScrollInfo.destroy();
      section._mediaBannerScrollInfo = null;
    }
    section._mediaBannerScrollInfo = new MediaBannerScrollInfo(section);
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeMediaBannerEvents) {
    window.__themeMediaBannerEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      const section = event.target;
      if (section && section._mediaBannerScrollInfo) {
        section._mediaBannerScrollInfo.destroy();
        section._mediaBannerScrollInfo = null;
      }
    });
  }
})();
